/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from "@emotion/react";
import { SquareLoader } from "components/atoms/loader/SquareLoader";
import { MEDIA_QUERY_FOR_PC } from "constants/mediaQueryForPc";
import { MEDIA_QUERY_FOR_SP } from "constants/mediaQueryForSp";
import { useI18n } from "hooks/i18n/i18n";

import { BlackButton } from "../BlackButton";

import type { MouseEventHandler } from "react";
import type { FcWithoutChildren } from "types/fcWithoutChildren";

type Props = {
  isLoading: boolean;
  isShown: boolean;
  onClickShowMore: MouseEventHandler<HTMLButtonElement>;
};

export const ShowMoreButton: FcWithoutChildren<Props> = (props) => {
  const { isLoading, isShown, onClickShowMore } = props;
  const { t } = useI18n();

  if (!isShown) return null;

  return (
    <div css={moreButtonWrapperStyle}>
      {isLoading ? (
        <div aria-busy="true" css={loadingStyle} role="status">
          <SquareLoader />
          <span css={screenReaderStyle}>Loading</span>
        </div>
      ) : (
        <BlackButton css={moreButtonStyle} onClick={onClickShowMore}>
          {t("search.moreRead")}
        </BlackButton>
      )}
    </div>
  );
};

const moreButtonWrapperStyle = css`
  text-align: center;

  ${MEDIA_QUERY_FOR_PC} {
    margin-top: 24px;
  }

  ${MEDIA_QUERY_FOR_SP} {
    margin-top: 10px;
  }
`;

const loadingStyle = css`
  display: inline-grid;
  height: 47px;
  place-content: center;
  width: 100%;
`;

// Bootstrap、Tailwind、Chakra UI 等で採用されてる screen reader 向けの隠しテキスト用スタイル
const screenReaderStyle = css`
  border: 0;
  clip: rect(0, 0, 0, 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  width: 1px;
`;

const moreButtonStyle = css`
  font-size: 18px;
  font-weight: 600;
  line-height: 1.5;
  padding: 10px 24px;
  width: 138px !important; /* BlackButton を上書き */
`;
